<template>
    <div class="right-icon">
        <div class="right-action">
            <div class="right-item webchart" v-if="screenWidth <1200">
                <img src="../../assets/images/common/webChart.png" @click="handleClick">
            </div>
            <div class="right-item webchart webchart-pc" v-else>
                <img src="../../assets/images/common/webChart.png">
                <div class="qr-code-div">
                    <img src="../../assets/images/common/qr_code.png" class="qr-code-img">
                </div>
            </div>
            <div class="right-item qq" >
                <a href="javascript:void(0);" data-qq="qq" @click="qqLink"><img src="../../assets/images/common/qq.png"></a>
            </div>
            <!--<div class="right-item qq"  v-if="screenWidth >= 1200">-->
                <!--<a href="http://wpa.qq.com/msgrd?v=3&uin=462769570&site=qq&menu=yes" target="_blank"><img src="../../assets/images/common/qq.png"></a>-->
            <!--</div>-->
            <!--<div class="right-item qq"  v-if="screenWidth <1200">-->
                <!--<a href="mqqwpa://im/chat?chat_type=wpa&uin=462769570&version=1&src_type=web" target="_blank"><img src="../../assets/images/common/qq.png"></a>-->
            <!--</div>-->
            <div class="top" v-show="isShowTopBtn">
                <img src="../../assets/images/common/top.png" @click="handleScrollTop">
            </div>
        </div>
        <!--联系方式弹框-->
        <van-dialog v-model="isShow" class="message-dialog" :showConfirmButton="false">
            <!--<div class="contact">-->
                <!--<div class="name">张经理</div>-->
                <!--<div class="tel">-->
                    <!--<img src="../../assets/phone/page/tel.png">-->
                    <!--18914740518-->
                <!--</div>-->
                <!--<div class="email">-->
                    <!--<img src="../../assets/phone/page/email.png">-->
                    <!--zhangliangping@njinst.com-->
                <!--</div>-->
            <!--</div>-->
            <img src="../../assets/images/common/qr_code.png" class="qr-code">
            <div class="close">
                <img src="../../assets/images/common/close.png" @click="isShow = false">
            </div>
        </van-dialog>
    </div>
</template>

<script>
export default {
    name: "rightIcon",
    props: ['isShowTopBtn'],
    data () {
        return {
            isShow: false, //弹框
            screenWidth: 0
        };
    },
    methods: {
        handleClick () {
            this.isShow = true;
            // window.open("http://bd.qq.com");
        },
        handleScrollTop () {
            if (this.$route.path==="/indexPage" || this.$route.path === "/") {
                $('#phone-page').animate({scrollTop: 0}, 500);
                this.$emit("backToTop");
            } else {
                $('body,html').animate({scrollTop: 0}, 500);
            }
            // this.$emit("scrollTop");
        },
        qqLink () {
            let kefu1_1 = "http://wpa.qq.com/msgrd?v=3&uin=462769570&site=oicqzone.com&menu=yes";
            let kefu1_2 = "mqqwpa://im/chat?chat_type=wpa&uin=462769570&version=1&src_type=web";
            let kefu1_3 = "mqq://im/chat?chat_type=wpa&uin=462769570&version=1&src_type=web&web_src=web";
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                window.open(kefu1_3);
            } else if (/(Android)/i.test(navigator.userAgent)) {
                window.open(kefu1_2);
            } else {
                window.open(kefu1_1);
            }
        }
    },
    mounted () {
        let that = this;
        this.$nextTick(()=> {
            that.screenWidth = document.documentElement.clientWidth;
        });
        $(window).bind('resize',function () {
            that.screenWidth = document.documentElement.clientWidth;
        });
    }
};
</script>

<style scoped lang="less">
    .right-action{
        position: fixed;
        right: 20px;
        &>div{
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 50px;
            border-radius: 8px;
            margin-top: 10px;
        }
        .right-item{
            background-color: rgba(86,164, 237, 0.75);
            border: 1px solid rgba(78,127,227,0.75);
            box-shadow:0px 0px 10px #1d6199;
            img{
                width: 1.2rem;
            }
            &.webchart{
                img{
                    width: 1.4rem;
                }
            }
            &.webchart-pc{
                position: relative;
                .qr-code-div{
                    position: absolute;
                    top: -110px;
                    left: -55px;
                    width: 100px;
                    height: 102px;
                    background-image: url("../../assets/images/common/qr_code_bg.png");
                    background-position: 0 center;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    display: none;
                    .qr-code-img{
                        width: 80px;
                        margin-top: 10px;
                    }
                }
                &:hover{
                    .qr-code-div{
                        display: block;
                    }
                }
            }
        }
        .top{
            margin-top: 10px;
            background-color: rgba(129,139, 144, 0.75);
            border: 1px solid rgba(98,98,98,0.75);
            box-shadow:0px 0px 10px #4a6174;
            img{
                margin-top: 8px;
                height: 1.2rem;
            }
        }
    }
    @media screen and (max-width: 1199px) {
        .right-action{
            bottom: 20px;
        }
    }
    @media screen and (min-width: 1200px) {
        .right-action{
            bottom: 96px;
            cursor: pointer;
            .top{
                &:hover{
                    background: rgba(165,170,175,0.75);
                    border: 1px solid rgba(155,155,155);
                }
            }
        }
    }
    .message-dialog{
        width: 60%;
        .qr-code{
            width: 90%;
        }
    }
/*.right-icon{*/
    /*position: fixed;*/
    /*right: 20px;*/
    /*bottom: 90px;*/
    /*.right-icon-width{*/
        /*.right-item{*/
            /*&.webchart{}*/
            /*&.qq{}*/
            /*&.top{}*/
        /*}*/
    /*}*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/common/rightIcon.vue